import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './Tag.scss';
import CloseButton from '../CloseButton';
import Text from '../Text';
import noop from 'lodash/noop';
import { dataHooks } from './Tag.helpers';
var tagToTextSize = {
  tiny: 'tiny',
  small: 'small',
  medium: 'small',
  large: 'medium'
};
/**
 * A Tag component
 */

var Tag = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Tag, _React$PureComponent);

  var _super = _createSuper(Tag);

  function Tag() {
    var _this;

    _classCallCheck(this, Tag);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "_handleRemoveClick", function (event) {
      var _this$props = _this.props,
          onRemove = _this$props.onRemove,
          id = _this$props.id;
      event.stopPropagation();
      onRemove(id);
    });

    return _this;
  }

  _createClass(Tag, [{
    key: "_renderThumb",
    value: function _renderThumb() {
      var thumb = this.props.thumb;
      return thumb ? /*#__PURE__*/React.createElement("span", {
        className: styles.thumb
      }, thumb) : null;
    }
  }, {
    key: "_renderText",
    value: function _renderText() {
      var _this$props2 = this.props,
          size = _this$props2.size,
          children = _this$props2.children,
          disabled = _this$props2.disabled,
          theme = _this$props2.theme;
      return /*#__PURE__*/React.createElement(Text, {
        skin: disabled ? 'disabled' : 'standard',
        light: theme === 'dark',
        secondary: theme !== 'dark',
        ellipsis: true,
        size: tagToTextSize[size],
        weight: size === 'tiny' ? 'thin' : 'normal',
        dataHook: dataHooks.text
      }, children);
    }
  }, {
    key: "_renderRemoveButton",
    value: function _renderRemoveButton() {
      var _this$props3 = this.props,
          removable = _this$props3.removable,
          disabled = _this$props3.disabled,
          size = _this$props3.size,
          theme = _this$props3.theme;

      if (removable) {
        return /*#__PURE__*/React.createElement(CloseButton, {
          size: size === 'large' ? 'medium' : 'small',
          skin: theme === 'dark' ? 'light' : 'dark',
          disabled: disabled,
          dataHook: dataHooks.removeButton,
          className: styles.removeButton,
          onClick: this._handleRemoveClick
        });
      } else {
        return null;
      }
    }
  }, {
    key: "_getClassName",
    value: function _getClassName() {
      var _classNames;

      var _this$props4 = this.props,
          thumb = _this$props4.thumb,
          removable = _this$props4.removable,
          size = _this$props4.size,
          disabled = _this$props4.disabled,
          theme = _this$props4.theme,
          className = _this$props4.className,
          onClick = _this$props4.onClick;
      return classNames(styles.root, className, styles["".concat(theme, "Theme")], styles["".concat(size, "Size")], (_classNames = {}, _defineProperty(_classNames, styles.withRemoveButton, removable), _defineProperty(_classNames, styles.withThumb, thumb), _defineProperty(_classNames, styles.disabled, disabled), _defineProperty(_classNames, styles.clickable, onClick !== noop), _classNames));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          id = _this$props5.id,
          _onClick = _this$props5.onClick,
          maxWidth = _this$props5.maxWidth,
          dataHook = _this$props5.dataHook;
      return /*#__PURE__*/React.createElement("span", {
        className: this._getClassName(),
        "data-hook": dataHook,
        id: id,
        onClick: function onClick(event) {
          return _onClick(id, event);
        },
        style: {
          maxWidth: "".concat(maxWidth, "px")
        }
      }, this._renderThumb(), this._renderText(), this._renderRemoveButton());
    }
  }]);

  return Tag;
}(React.PureComponent);

_defineProperty(Tag, "displayName", 'Tag');

Tag.propTypes = {
  /** Applied as data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,

  /** The text of the tag */
  children: PropTypes.node.isRequired,

  /** when set to true this component is disabled */
  disabled: PropTypes.bool,

  /** The id of the Tag  */
  id: PropTypes.string.isRequired,

  /** Callback function that pass `id` property as first parameter
   * and mouse event as second parameter when clicking on Tag */
  onClick: PropTypes.func,

  /** Callback function that pass `id` property as parameter when removing the Tag  */
  onRemove: PropTypes.func,

  /** If the Tag is removable then it will contain a small clickable X */
  removable: PropTypes.bool,

  /** The height of the Tag */
  size: PropTypes.oneOf(['tiny', 'small', 'medium', 'large']),

  /** theme of the Tag */
  theme: PropTypes.oneOf(['standard', 'error', 'warning', 'dark', 'neutral', 'light']),

  /** An optional thumb to display as part of the Tag */
  thumb: PropTypes.element,

  /** An optional maximum tag width in `px` for cropping. */
  maxWidth: PropTypes.number,

  /** Standard className which has preference over any other intrinsic classes  */
  className: PropTypes.string
};
Tag.defaultProps = {
  onClick: noop,
  onRemove: noop,
  size: 'small',
  removable: true,
  theme: 'standard'
};
export default Tag;